import React, { useState,useEffect} from "react";
import { MDBInput } from "mdb-react-ui-kit";
import Select from "react-select";
import NotificationAlert from "react-notification-alert";
import {
  Row,
  Col,
  Input,
  FormGroup,
  UncontrolledTooltip,
  Button,
  Card,
  CardBody,
} from "reactstrap";
import axios from "axios";
import apiService from "../../variables/apiService";

import { EMAIL_INSTANT,CHANNEL_CLIENT_CHNLTYPE } from "../../constants";



var initialvalues = {
  recipientEmail: "",
  fromEmail: "",
  subject: "",
  body: "",
  templateid: "",
  sender:""
};
let userObj = localStorage.getItem("user");
let user = JSON.parse(userObj);
let templates = [];
let senderids = [];
const InstantEmails = () => {
  const [emaildata, setEmaildata] = useState(initialvalues);
  const [count, setCount] = React.useState(0);
  const notificationAlertRef = React.useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [errorhandle,setErrorHandle]= useState()
  const [channel, setChannel] = useState([]);

  useEffect(()=>{
    fetchChanelsbyClient();
  },[])

  const fetchChanelsbyClient=async()=>{
    setIsLoading(true)

    const payload={
      channels_type:"email",
      clintId:user?.client
    }
    user?.client!=0&&(await axios.post(CHANNEL_CLIENT_CHNLTYPE,payload).then(res=>{
    
      if(res?.data){
      templates=[]
      
      setChannel(res?.data)
     
      res?.data?.map((item,i)=>{
        item?.template&&templates.push({ value:item?.template, label: item?.template })
        
      })
 
    }
      setIsLoading(false)
     }).catch(e=>{
     
      let options = {};
          options = {
            place: "tr",
            message: "Template Not Found",
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef?.current?.notificationAlert(options);
    }))

  }

  const changeSender=(data)=>{
 
    senderids=[]
    const chnl=channel.filter(item=>item.template==data.value)
      
    const senderid = chnl[0]?.senderid?.split(",");
        for(let i=0;i<senderid?.length;i++){
          senderids.push({label:senderid[i],value:senderid[i]})
        }
    
    setEmaildata(prev=>({...prev,templateid:data,sender:""}))
  }

  const submitFields = async () => {
    let options = {};
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]/i;

    if (!emailRegex.test(emaildata.recipientEmail)) {
      options = {
        place: "tr",
        message: "RecipientEmail required",
        type: "warning",

        autoDismiss: 3,
      };
      notificationAlertRef.current.notificationAlert(options);
    } else if (emaildata.subject == "") {
      options = {
        place: "tr",
        message: "Subject required",
        type: "warning",

        autoDismiss: 3,
      };
      notificationAlertRef.current.notificationAlert(options);
    } else if (emaildata.body == "") {
      options = {
        place: "tr",
        message: "Body required",
        type: "warning",

        autoDismiss: 3,
      };
      notificationAlertRef.current.notificationAlert(options);
    } else {
      let payload = {
        recipientEmail: emaildata.recipientEmail.split(","),
        templateid: emaildata.templateid.value,
        subject: emaildata.subject,
        body: emaildata.body,
        fromEmail: emaildata.sender.value,
      };

      apiService
        .postData(EMAIL_INSTANT, payload)
        .then(async (response) => {
          setIsLoading(true)
          await sendMail(payload);
          let options = {};
          options = {
            place: "tr",
            message: "Sent Successfully",
            type: "success",

            autoDismiss: 2,
          };
          setEmaildata(initialvalues);
          setIsLoading(false)
          notificationAlertRef.current.notificationAlert(options);
        })
        .catch((err) => console.log("err==>", err));
    }
  };
  const sendMail = (payd) => {
    let tomails = payd.recipientEmail;
    for (let i = 0; i < tomails.length; i++) {
      let payload = {
        owner_id: "50162199",
        token: "x2b3CCATdcxnYQ5b2X8o",
        smtp_user_name: "smtp88192588",
        message: {
          html: payd.body,
          subject: payd.subject,
          from_email: payd.fromEmail,
          from_name: "igl",
          to: [
            {
              email: tomails[i],
              name: "igl",
              type: "to",
            },
          ],
          headers: {
            "Reply-To": "message.reply@example.com",
            "X-Unique-Id": "<1581377197.119.1699199360726@PRDOTEXT2>",
          },
        },
      };

      axios
        .post("https://api.sendclean.net/v1.0/messages/sendMail", payload)
        .then((response) => {
         
          // let options = {};
          // options = {
          //   place: "tr",
          //   message: "Email Sent Successfully",
          //   type: "success",
          //   autoDismiss: 2,
          // };
          // notificationAlertRef.current.notificationAlert(options);
        })
        .catch((err) => console.log("email err==>", err));
    }
  };
  return (
    <div className="content">
      <Card>
        <CardBody>
          <div>
            <Row className="mb-4 ">
              <NotificationAlert ref={notificationAlertRef} />
              <Col md="4" sm="12" className="mt-4 ">
                <MDBInput
                  label="*Recipient Email "
                  type="email"
                  value={emaildata.recipientEmail}
                  name="recipientEmail"
                  placeholder="abc@mail.com,xyz@mail.com"
                  onChange={(e) => {
                    setEmaildata({
                      ...emaildata,
                      recipientEmail: e.target.value,
                    });
                  }}
                />
              </Col>
              {/* <Col md="4" sm="12" className="mt-4">
                <MDBInput
                  label="From Email"
                  type="text"
                  value={emaildata.company_email}
                  disabled={true}
                  name="fromemail"
                  className="no-spinner"
                />
              </Col> */}
              {/* <Col md="4" sm="12">
          <p className="category">Select </p>
          <Select
            className="react-select info"
            classNamePrefix="react-select"
            name="singleSelect"
            value={singleSelect}
            onChange={(value) => setsingleSelect(value)}
            options={instantDrpdwn}
            placeholder="Select"
            
          />
        </Col> */}
          <Col md="4" sm="12">
          <p className="category">Select Template<suf style={{color:"red"}}>*</suf> </p>
          <Select
            className="react-select info"
            classNamePrefix="react-select"
            name="templateSelect"
            value={emaildata.templateid}
            onChange={(value) =>  changeSender(value)}
            options={templates}
            placeholder="Select"
          />
          {errorhandle?.templateid&&<span style={{color:"red"}}>{errorhandle?.templateid}</span>}
        </Col>
        <Col md="4" sm="12">
          <p className="category">Select Sender<suf style={{color:"red"}}>*</suf> </p>
          <Select
            className="react-select info"
            classNamePrefix="react-select"
            name="senderSelect"
            value={emaildata?.sender}
            onChange={(value) => setEmaildata(prev=>({...prev,sender:value}))}
            options={senderids}
            placeholder="Select"
          />
           {errorhandle?.sender&&<span style={{color:"red"}}>{errorhandle?.sender}</span>}
        </Col>
            </Row>
            <Row>
              <Col md="4" sm="12">
                <label>*Subject </label>
                <FormGroup>
                  <Input
                    type="textarea"
                    placeholder="Enter Subject"
                    maxLength={160}
                    value={emaildata?.subject?.substring(0, 160)}
                    onChange={(e) => {
                      setEmaildata({
                        ...emaildata,
                        subject: e.target.value,
                      });
                      setCount(e.target.value.length);
                    }}
                  />
                  <label style={{ float: "right" }}>
                    {160 - count == 160 ? 0 : 160 - count} / 160
                  </label>
                </FormGroup>
              </Col>
              <Col md="4" sm="12">
                <label>*Body </label>
                <FormGroup>
                  <Input
                    type="textarea"
                    placeholder="Enter Message"
                    value={emaildata.body}
                    onChange={(e) => {
                      setEmaildata({
                        ...emaildata,
                        body: e.target.value,
                      });
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md="3" sm="3">
                <Button
                  color="primary "
                  className="mt-4 btn btn-icon animation-on-hover"
                  id="tooltipsubmit"
                  type="button"
                  onClick={() => submitFields()}
                >
                  <i className="tim-icons icon-double-right" />
                </Button>
                <UncontrolledTooltip
                  delay={0}
                  placement="top"
                  target="tooltipsubmit"
                >
                  Submit
                </UncontrolledTooltip>
              </Col>
            </Row>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default InstantEmails;
